module.exports = __webpack_public_path__ + "img/IMAGE 6.31af4b1b.png";